<template>
  <div class="summary-content" :id="chartId">
    <div class="hidden-chart-name">
      {{title}} <b>{{charDateTitle}}</b>
    </div>

    <div class="dynamic-chart__wrap">
      <div class="dynamic-chart__wrap-item">
        <bar-chart-dynamic
          v-if="isLoaded"
          :chart-data="dataBarCollection"
          :options="barOptions"
          class="summary-content__chart"
          :height="400"
          selector=".dynamic-chart__wrap-item"
        ></bar-chart-dynamic>
      </div>
    </div>

    <div class="chart-show-labels" data-html2canvas-ignore="true" @click="toggleLabel">
      <el-checkbox :value="showLabel" @change="toggleLabel">{{$t('feed.audit.likesAndReposts.body.captions')}}</el-checkbox>
    </div>
    <a href="" :id="`download${chartId}`"></a>
  </div>
</template>

<script>
  // chart
  import { BarChartDynamic } from "../../../../../../../../components/charts";

  // mixins
  import summary from "../../../../../../../../mixins/chart/SummaryLikesAndReposts";
  import saveImage from "../../../../../../../../mixins/saveImage";

  // moment
  import moment from 'moment';

  export default {
    name: "SummaryLikesAndRepostsBody",
    props: {
      data: {
        type: Array,
        required: true
      },
      chartName: {
        type: String
      },
      saveChart: {
        type: Boolean,
        default: false
      },
      title: {
        type: String
      }
    },
    methods: {
      toggleLabel () {
        this.showLabel = !this.showLabel;
      },
    },
    data() {
      return {
        chartId: "SummaryLikesAndReposts",
        format: "DD.MM.YYYY",
        showLabel: true,
      }
    },
    computed: {
      chartDate() {
        return this.$store.getters.getAuditPeriod(this.chartName);
      },
      isLoaded() {
        return this.$store.getters.auditData.length;
      },
      charDateTitle () {
        return `${moment(this.chartDate[0]).format(this.format)} - ${moment(this.chartDate[1]).format(this.format)}`;
      },
    },
    mixins: [
      summary,
      saveImage
    ],
    components: {
      BarChartDynamic
    }
  };
</script>

<style>
  @import "../../../../../../../../style/tonal.css";
  .dynamic-chart__wrap {
    position: relative;
    overflow-x: auto;
    height: 425px;
  }
  .dynamic-chart__wrap-item {
    position: relative;
  }
  .summary-content__chart {
    margin-bottom: 10px;
  }
  .chart-show-labels {
    display: flex;
    justify-content: start;
    padding: 20px 10px;
    font-size: 16px;
  }
</style>
